/* eslint-disable max-len */

const data = {
  en: {
    translation: {
      actions: {
        activate_account: 'Activate Account',
        forgot_password: 'Forgot your password?',
        need_to_setup_account: 'Need to set up an account?',
        request_online_access: 'Interested in signing up for online access? Please contact your property manager.',
        sign_in: 'Sign In',
      },
      errors: {
        invalid_login: 'Invalid email or password.',
        already_activated: 'This email address needs to be activated. Request activation.',
        general_error: 'Something went wrong. Please try again.'
      },
      messages: {
        activation_terms_of_service: 'By checking this box, I certify that I agree to the ' +
          '{{- terms_of_service_link}} and {{- privacy_policy_link}}',
        already_used_activation: 'This activation code has already been used.',
        terms_of_service_link: '<a href="https://www.appfolio.com/terms/homeowner_tenant_portal" ' +
          'target="_blank">Terms of Service</a>',
        privacy_policy_link: '<a href="https://www.appfolio.com/privacy" target="_blank">Privacy Policy</a>',
        password_requirements: {
          intro: 'Passwords must',
          length: 'Be at least 8 characters',
          letter: 'Contain at least 1 letter',
          number: 'Contain at least 1 number',
          symbol: 'Contain at least 1 symbol'
        }
      },
      labels: {
        activate_your_online_portal: 'Activate Your Online Portal',
        email: 'Email',
        create_password: 'Create Password',
        online_portal: 'Online Portal',
        password: 'Password'
      },
      navigation: {
        visit_our_website: 'Visit Our Website',
        help: 'Help',
        help_site_link: {
          hoa: 'https://www.appfolio.com/help/HOA-online-portal',
          non_hoa: 'https://www.appfolio.com/help/online-portal'
        },
        privacy: 'Privacy',
        terms: 'Terms'
      }
    }
  },
  es: {
    translation: {
      actions: {
        activate_account: 'Activar la cuenta',
        forgot_password: '¿Olvidó su contraseña?',
        need_to_setup_account: '¿Necesita configurar una cuenta?',
        request_online_access: '¿Está interesado en registrarse para obtener acceso en línea? Póngase en contacto con el administrador de su propiedad.',
        sign_in: 'Iniciar sesión',
      },
      errors: {
        invalid_login: 'Correo electrónico o contraseña no válidos.',
        already_activated: 'Esta dirección de correo electrónico debe activarse. Solicitar activación.',
        general_error: 'Algo salió mal. Inténtalo de nuevo.'
      },
      messages: {
        activation_terms_of_service: 'Al marcar esta casilla, acepto los ' +
          '{{- terms_of_service_link}} y la {{- privacy_policy_link}}',
        already_used_activation: 'Ya se ha usado esta clave de activación.',
        terms_of_service_link: '<a href="https://www.appfolio.com/terms/homeowner_tenant_portal" ' +
          'target="_blank">Términos de servicio</a>',
        privacy_policy_link: '<a href="https://www.appfolio.com/privacy" target="_blank">Política de privacidad</a>',
        password_requirements: {
          intro: 'Las contraseñas deben:',
          length: 'Tener al menos 8 caracteres',
          letter: 'Contener al menos 1 letra',
          number: 'Contener al menos 1 número',
          symbol: 'Contener al menos 1 símbolo'
        }
      },
      labels: {
        activate_your_online_portal: 'Active su portal en línea',
        email: 'Correo electrónico',
        create_password: 'Crear contraseña',
        online_portal: 'Portal en línea',
        password: 'Contraseña'
      },
      navigation: {
        visit_our_website: 'Visite nuestra página de internet',
        help: 'Ayuda',
        help_site_link: {
          hoa: 'https://www.appfolio.com/help/HOA-online-portal-es',
          non_hoa: 'https://www.appfolio.com/help/online-portal-es'
        },
        privacy: 'Privacidad',
        terms: 'Condiciones'
      }
    }
  }
};

export default data;
